import * as Context from "effect/Context";
import * as Layer from "effect/Layer";
import * as LogLevel from "effect/LogLevel";
import * as Logger from "effect/Logger";
import * as ManagedRuntime from "effect/ManagedRuntime";
import * as Match from "effect/Match";
export const Config = Context.GenericTag("Config");
export const defaultConfig = {
    reloadUrl: "/",
    syncUrl: "https://evolu.world",
    name: "Evolu",
    maxDrift: 5 * 60 * 1000,
    minimumLogLevel: "none",
};
/** https://effect.website/docs/guides/runtime */
export const createRuntime = (partialConfig) => {
    const config = { ...defaultConfig, ...partialConfig };
    const ConfigLive = Layer.succeed(Config, config);
    const minimumLogLevel = Match.value(config.minimumLogLevel).pipe(Match.when("debug", () => LogLevel.Debug), Match.when("none", () => LogLevel.None), Match.when("trace", () => LogLevel.Trace), Match.when("warning", () => LogLevel.Warning), Match.exhaustive);
    const evoluLayer = config.minimumLogLevel === "none"
        ? ConfigLive
        : Layer.mergeAll(ConfigLive, Logger.minimumLogLevel(minimumLogLevel), Logger.replace(Logger.defaultLogger, makeEvoluLogger(config.name)));
    return ManagedRuntime.make(evoluLayer);
};
// TODO: Spans and Effect native variadic log args.
const makeEvoluLogger = (name) => Logger.make(({ logLevel, message, date }) => {
    const fn = logLevel._tag === "Warning"
        ? "warn"
        : logLevel._tag === "Error"
            ? "error"
            : "log";
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");
    const milliseconds = date.getMilliseconds().toString().padStart(3, "0");
    const formattedDate = `${hours}:${minutes}:${seconds}:${milliseconds}`;
    const messages = Array.isArray(message) ? message : [message];
    globalThis.console[fn](`${formattedDate} [${name}]`, ...messages);
});
